function Rule() {
    return (
        <div className="container-fluid p-0">
            <img
                src="/assets/images/terms-and-rules/rules.jpg"
                alt="قالب تصویری قوانین و مقررات"
                className="img-fluid d-block w-100"
            />
        </div>
    );
}

export default Rule;